<script lang="ts">
	import ButtonAsync from '$lib/utils/components/ButtonAsync.svelte';
	import FaIcon from '$lib/utils/components/FaIcon.svelte';

	import { geo_state } from '$lib/features/geo/states/geo_state.svelte';
	import { driver_state } from '../states/driver_state';
	import { toast } from '$lib/utils/toast';

	async function handle_availability_click() {
		try {
			const driver = driver_state.value;
			if (!driver) return false;
			const new_state = !driver.is_active;
			if (new_state) {
				const success = await geo_state.watch_position();
				if (!success) throw 'failed_to_obtain_location_permission';
			} else {
				await geo_state.clear_watch_position();
			}

			const update_op = await driver_state.update_one({
				input: {
					pk_columns: { id: driver.id },
					_set: { is_active: new_state }
				}
			});

			if (!update_op) throw 'failed|update_availibility';
			toast.success('success|update_availibility');
			return true;
		} catch (error) {
			console.error({ error });
			await geo_state.clear_watch_position();
			if (typeof error === 'string') toast.error(error);
			return false;
		}
	}
	const is_active = $derived(driver_state.value?.is_active ? true : false);
</script>

<ButtonAsync
	class="{is_active
		? 'bg-success'
		: 'bg-destructive'} relative  border-2 border-background text-primary-foreground duration-300 ease-linear flex h-10 w-10 cursor-pointer items-center justify-center rounded-full
hover:bg-muted hover:text-primary hover:duration-300 hover:ease-linear"
	type="button"
	onclick={handle_availability_click}
>
	<FaIcon name={is_active ? 'faLightbulb' : 'faMoon'} />
</ButtonAsync>
